import React, { FC, PropsWithChildren } from 'react';

import Tooltip from 'vibo-ui/Tooltip';

interface SpotifySyncTooltipProps {
  disabled?: boolean;
}

const SpotifySyncTooltip: FC<PropsWithChildren<SpotifySyncTooltipProps>> = ({
  disabled,
  children,
}) => {
  return (
    <Tooltip
      overlay={disabled ? 'To add or edit songs, please turn off Spotify synchronization.' : ''}
      type="black"
    >
      <span>{children}</span>
    </Tooltip>
  );
};

export default SpotifySyncTooltip;
